import { useTranslation } from 'react-i18next';

export default function KeyMetrics() {
  const { t } = useTranslation();

  const metrics = [
    { value: '35%', labelKey: 'metrics.ahorro', icon: 'ri-percent-line' },
    { value: '+12.000', labelKey: 'metrics.co2', icon: 'ri-leaf-line' },
    { value: '+200', labelKey: 'metrics.proyectos', icon: 'ri-checkbox-circle-line' },
    { value: '98%', labelKey: 'metrics.satisfaccion', icon: 'ri-emotion-happy-line' }
  ];

  return (
    <section className="py-20 bg-teal-600">
      <div className="container mx-auto px-4">
        <div className="text-center mb-12">
          <h2 className="text-3xl font-bold text-white mb-4">
            {t('metrics.titulo')}
          </h2>
          <p className="text-teal-100 text-lg">
            {t('metrics.subtitulo')}
          </p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-8 max-w-5xl mx-auto">
          {metrics.map((metric, index) => (
            <div key={index} className="text-center">
              <div className="w-16 h-16 bg-white/20 rounded-full flex items-center justify-center mx-auto mb-4">
                <i className={`${metric.icon} text-3xl text-white`}></i>
              </div>
              <div className="text-4xl font-bold text-white mb-2">{metric.value}</div>
              <div className="text-teal-100">{t(metric.labelKey)}</div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
